<template>
  <div style="padding-right: 30px">
    <el-form ref="form" :model="form" label-width="20px">
      <el-form-item>
        <el-input
          v-model="form.message"
          type="textarea"
          :rows="6"
          placeholder="请输入内容" 
          clearable
        />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="messageSend('SMS')">短信推送</el-button>
        <el-button type="primary" @click="messageSend('APP')">应用推送</el-button>
        <el-button @click="$emit('pushed')">取消</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { pushEvaluationManagement } from "@/api/CustomerService";
export default {
  name: "TransportAbnormalDetail",
  data() {
    return {
      form: {
        message:'由于您收到的运单评价分数较低，请及时查看评价低分项原因并对低分评价项及时改善，若不能及时提高评价，平台将进行账号冻结退出处理，特此通知'
      },
      driverCodes: '',
      shipmentCodes: '',
    };
  },
  created() {
    
  },
  methods: {
    setcodes(data){
      let driverCodes = []
      let shipmentCodes = []
      data.map(item=>{
        if(item.partyType=='SHIPMENT'||item.partyType=="SHIPMENT_COMPANY"){
          shipmentCodes.push(item.userCode)
        }
        else{
           driverCodes.push(item.userCode)
        }
      })
      this.driverCodes = driverCodes.join(',')
      this.shipmentCodes = shipmentCodes.join(',')
    },
    async messageSend(type){
      const rLoading = this.openLoading();
      let formData = {
        driverCodes: this.driverCodes,
        shipmentCodes: this.shipmentCodes,
        pushMsg: this.form.message,
        pushType: type
      }
      let response = await pushEvaluationManagement(formData)
      rLoading.close()
      this.$message.success(response.msg)
      this.$emit('pushed')
    },
  }
};
</script>
